import { useMemo } from 'react';
import { AccountCircle } from '@mui/icons-material';
import { Avatar, Card, CardContent, CardHeader, CardProps, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Action, ScheduledAction, ScheduledActionFragmentFragment } from '../../api/gql';
import { ActionIcon } from './ScheduledActionIcon';

type Props = {
  scheduledAction: ScheduledActionFragmentFragment;
} & CardProps;
export const InvoiceScheduledActionNote = ({ scheduledAction, ...cardProps }: Props) => {
  const { t } = useTranslation();

  const doneAtString = useMemo(
    () => (scheduledAction.doneAt ? format(new Date(scheduledAction.doneAt), 'dd.MM.Y, kk:mm') : ''),
    [scheduledAction.doneAt],
  );

  const inResponseToString = useMemo(() => {
    switch (scheduledAction.action) {
      case Action.Email:
        return t('inResponseTo.email');
      case Action.Sms:
        return t('inResponseTo.sms');
      case Action.Call:
        return t('inResponseTo.call');
      default:
        return '';
    }
  }, [scheduledAction.action, t]);

  if (!scheduledAction.note) {
    return null;
  }

  return (
    <Card {...cardProps}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            <AccountCircle />
          </Avatar>
        }
        title={t('ourOperator')}
        subheader={
          <Typography fontSize={'small'} color={'text.secondary'}>
            {doneAtString}・{inResponseToString}・<ActionIcon action={scheduledAction.action} fontSize={'inherit'} />
          </Typography>
        }
      />
      <CardContent sx={{ py: 0, pl: 9 }}>
        <Typography variant={'body2'}>{scheduledAction.note}</Typography>
      </CardContent>
    </Card>
  );
};
